export const MIN_TRACK_GAIN_DB = -24
export const MAX_TRACK_GAIN_DB = 3
export const DEFAULT_TRACK_GAIN_DB = 0

export const clampTrackGainDb = (gainDb: number): number => {
  const clamped = Math.min(
    MAX_TRACK_GAIN_DB,
    Math.max(MIN_TRACK_GAIN_DB, gainDb)
  )
  return Math.round(clamped * 10) / 10
}

export const gainDbToLinear = (gainDb: number): number =>
  Math.pow(10, clampTrackGainDb(gainDb) / 20)

/** 0 at min gain (−24 dB), 100 at max gain (+3 dB). */
export const trackGainDbToPercent = (gainDb: number): number => {
  const clamped = clampTrackGainDb(gainDb)
  return (
    ((clamped - MIN_TRACK_GAIN_DB) / (MAX_TRACK_GAIN_DB - MIN_TRACK_GAIN_DB)) *
    100
  )
}
